
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaFileExcel, FaFilePdf, FaTimes } from "react-icons/fa";
import { format, subDays } from "date-fns";
import "./ConsolidatedReport.css";

const App = () => {
  const [searchInput, setSearchInput] = useState("");
  const [selectedVehicles, setSelectedVehicles] = useState([
    "KA02AH7852 (VEHICLE)",
    "KA 01 B 7947 (VEHICLE)",
  ]);
  const [dateRange, setDateRange] = useState("Last Day");
  const [startDate, setStartDate] = useState(
    format(subDays(new Date(), 1), "yyyy-MM-dd")
  );
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"));

  const removeVehicle = (vehicle) => {
    setSelectedVehicles(selectedVehicles.filter((v) => v !== vehicle));
  };

  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    setDateRange(value);

    const today = new Date();
    switch (value) {
      case "Last Day":
        setStartDate(format(subDays(today, 1), "yyyy-MM-dd"));
        setEndDate(format(today, "yyyy-MM-dd"));
        break;
      case "Last 7 Days":
        setStartDate(format(subDays(today, 7), "yyyy-MM-dd"));
        setEndDate(format(today, "yyyy-MM-dd"));
        break;
      case "Custom":
        // Keep current dates for custom selection
        break;
      default:
        break;
    }
  };

  const reportDetails = [
    { label: "Group Name", value: "-" },
    { label: "Start Address", value: "-" },
    { label: "End Address", value: "-" },
    { label: "Total Running Time", value: "-" },
    { label: "Total HA Count", value: "-" },
    { label: "Average Speed", value: "-" },
    { label: "Total Idling Time", value: "-" },
    { label: "Driver Name", value: "-" },
    { label: "Driving Score (%)", value: "-" },
    { label: "Total Overspeed Time", value: "-" },
    { label: "Total Night Running Time (10PM to 5AM)", value: "-" },
  ];

  const reportDetailsRight = [
    { label: "Start Time", value: "-" },
    { label: "End Time", value: "-" },
    { label: "Total Distance", value: "-" },
    { label: "Total Halt Time", value: "-" },
    { label: "Total HB Count", value: "-" },
    { label: "Max Speed", value: "-" },
    { label: "Total Overspeed Distance", value: "-" },
    { label: "Driver Contact Number", value: "-" },
    { label: "Total Overspeed Count", value: "-" },
    { label: "Total Day Running Time (5AM to 10PM)", value: "-" },
    { label: "Total Customized Alerts", value: "-" },
  ];
  const handleReset = () => {
    setSearchInput("");
    setSelectedVehicles(["KA02AH7852 (VEHICLE)", "KA 01 B 7947 (VEHICLE)"]);
    setDateRange("Last Day");
    setStartDate(format(subDays(new Date(), 1), "yyyy-MM-dd"));
    setEndDate(format(new Date(), "yyyy-MM-dd"));
  };

  return (
    <div className="Consolidated-report-container">
      <h1 className="report-title">Consolidated Report</h1>
      <hr className="Consolidated-report-line" width="100%" />
      <div className="controls-container">
        <div className="search-container-Consolidated">
          <FaSearch className="search-icon-Consolidated" />
          <input
            type="text"
            placeholder="Search Vehicles or Groups"
            className="search-input-Consolidated"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
        </div>

        <div className="date-range-container">
          <label className="control-label">Date Range</label>
          <select
            value={dateRange}
            onChange={handleDateRangeChange}
            className="date-range-select"
          >
            <option>Last Day</option>
            <option>Last 7 Days</option>
            <option>Custom</option>
          </select>
        </div>

        <div className="date-input-container">
          <label className="control-label">Start Date:</label>
          <input
            type="date"
            className="date-input"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            disabled={dateRange !== "Custom"}
          />
        </div>

        <div className="date-input-container">
          <label className="control-label">End Date:</label>
          <input
            type="date"
            className="date-input"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            disabled={dateRange !== "Custom"}
          />
        </div>

        <button className="generate-report-btn">GENERATE REPORT</button>

        <button className="action-btn-Consolidated reset-btn" onClick={handleReset}>
          RESET
        </button>
        <Link to="/Report">
          <button className="action-btn-Consolidated back-btn">
            BACK TO ALL REPORTS
          </button>
        </Link>
        <FaFileExcel className="excel-icon file-icon" title="Export to Excel" />
        <FaFilePdf className="pdf-icon file-icon" title="Export to PDF" />
      </div>

      <div className="selected-vehicles-container">
        {selectedVehicles.map((vehicle, idx) => (
          <span key={idx} className="vehicle-tag">
            {vehicle}
            <FaTimes
              className="remove-icon"
              onClick={() => removeVehicle(vehicle)}
              title="Remove vehicle"
            />
          </span>
        ))}
      </div>
         <div className="reportDataContainer-Consolidated">
        <div className="reportColumn-Consolidated">
          {reportDetails.map((item, index) => (
            <div key={index} className="reportItem-Consolidated">
              <span className="reportLabel-Consolidated">{item.label}</span>
              <span className="reportValue-Consolidated">{item.value}</span>
            </div>
          ))}
        </div>
        <div className="reportColumn-Consolidated">
          {reportDetailsRight.map((item, index) => (
            <div key={index} className="reportItem-Consolidated">
              <span className="reportLabel-Consolidated">{item.label}</span>
              <span className="reportValue-Consolidated">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
       
    </div>
  );
};

export default App;
 

